import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 9.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M7.5 16a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0M16 1a1 1 0 0 1 1 1v2.5a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1M5.393 5.393a1 1 0 0 1 1.414 0L8.57 7.155A1 1 0 0 1 7.155 8.57L5.393 6.807a1 1 0 0 1 0-1.414M1 16a1 1 0 0 1 1-1h2.5a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1M8.57 23.43a1 1 0 0 1 0 1.415l-1.763 1.762a1 1 0 0 1-1.414-1.414l1.762-1.763a1 1 0 0 1 1.415 0M16 26.5a1 1 0 0 1 1 1V30a1 1 0 1 1-2 0v-2.5a1 1 0 0 1 1-1M23.43 23.43a1 1 0 0 1 1.415 0l1.762 1.763a1 1 0 0 1-1.414 1.414l-1.762-1.762a1 1 0 0 1 0-1.415M26.5 16a1 1 0 0 1 1-1H30a1 1 0 1 1 0 2h-2.5a1 1 0 0 1-1-1M26.607 5.393a1 1 0 0 1 0 1.414L24.845 8.57a1 1 0 1 1-1.414-1.415l1.762-1.762a1 1 0 0 1 1.414 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconSun = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSun);
export default Memo;
